import { get } from './api';

export const getPage = (id, autostep = false) =>
  get('CMSPAGE', 'api', `/pages/v2/pages?pageName=${id}&autostep=${autostep}`);
